//
//
//
//
//
//
//
//
//
//
//
//

import SearchItemDropdown from '@/components/search/SearchItemDropdown'

export default {
  name: 'TypesDropdown',
  components: {
    SearchItemDropdown
  },
  props: {
    selected: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    types () {
      return [
        {
          id: 'fulltime',
          name: this.$t('tasks.form.fulltime')
        },
        {
          id: 'parttime',
          name: this.$t('tasks.form.parttime')
        },
        {
          id: 'onetime',
          name: this.$t('tasks.form.onetime')
        }
      ]
    },
    label () {
      return this.selected ? this.types.find(t => t.id === this.selected).name : this.$t('tasks.selectType')
    }
  },
  methods: {
    handleSelectItem (item) {
      this.$emit('select', item.id)
    },
    handleRemoveSelection () {
      this.$emit('select', null)
    }
  }
}
